/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CustomerTransactionType {
    DEPOSIT = 'Deposit',
    BONUS = 'Bonus',
    WITHDRAWAL = 'Withdrawal',
    WITHDRAWAL_REQUEST = 'WithdrawalRequest',
    TRANSFER = 'Transfer',
    EARN_TOP_UP = 'EarnTopUp',
    EARN_REDEMPTION = 'EarnRedemption',
    EARN_TERMINATION = 'EarnTermination',
    EARN_REWARD = 'EarnReward',
    PAYMENT_CARD_PURCHASE_FEE = 'PaymentCardPurchaseFee',
    PAYMENT_CARD_TOP_UP = 'PaymentCardTopUp',
}
